import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
  fetchAllAdminUsers,
  type AdminUsersResponse,
} from '../../services/userManager';

export const adminUsersDirectoryQueryKey = ['admin', 'users', 'directory'];

export function useAdminUsersDirectoryQuery(
  options?: UseQueryOptions<AdminUsersResponse, Error>
) {
  return useQuery<AdminUsersResponse, Error>({
    queryKey: adminUsersDirectoryQueryKey,
    queryFn: async () => fetchAllAdminUsers(),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
}
